import React, { Component } from "react";
import { isChunkLoadError } from "../../utils/lazyWithRetry";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, isChunkError: false };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      isChunkError: isChunkLoadError(error),
    };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);

    if (isChunkLoadError(error) && !sessionStorage.getItem("caf-chunk-reload")) {
      sessionStorage.setItem("caf-chunk-reload", "1");
      window.location.reload();
    }
  }

  handleRetry = () => {
    sessionStorage.removeItem("caf-chunk-reload");
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div className="caf-products-state mx-auto max-w-lg px-4 py-16 text-center">
            <p className="caf-section-title text-xl">Something went wrong</p>
            <p className="caf-section-subtitle mt-2">
              {this.state.isChunkError
                ? "The page could not load. This can happen after an update — tap below to refresh."
                : "Please refresh the page or try again later."}
            </p>
            <button
              type="button"
              onClick={this.handleRetry}
              className="caf-btn caf-btn--primary mt-6"
            >
              Refresh page
            </button>
          </div>
        )
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
